import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';

export const useAdminConsoleTabsStyles = createStyles(({ token }) => ({
  tabs: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `0 ${ThemeSpaces.SPACE_XL}px`,
    backgroundColor: ThemeColors.COLOR_GREY9_8,
    borderTop: `1px solid ${ThemeColors.COLOR_GREY7_8}`,
    borderBottom: `1px solid ${token.colorWhite}`,
    margin: `0 -${ThemeSpaces.SPACE_NORM_20}px`,
  },
  section: {
    display: 'flex',
    alignItems: 'center',
    gap: ThemeSpaces.SPACE_SM,
    color: token.colorPrimary,
    fontWeight: token.fontWeightStrong,
    fontSize: ThemeFont.FONT_SIZE_20,
    fontFamily: ThemeFont.FONT_CONDENSED,
  },
  sectionIcon: {
    fontSize: 18,
  },
  links: {
    display: 'flex',
    alignItems: 'center',
    gap: ThemeSpaces.SPACE_NORM_20,
  },
  link: {
    fontSize: ThemeFont.FONT_SIZE_LG_MINUS,
    fontWeight: token.fontWeightStrong,
    fontFamily: ThemeFont.FONT_CONDENSED,
    color: ThemeColors.COLOR_GREY6,

    '&:hover': {
      color: token.colorPrimary,
    },

    '&.active': {
      color: token.colorPrimary,
      textDecoration: 'underline',
    },
  },
}));
